import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UrlSafePipe } from '../../../modules/catch-core/pipes/pipes/url-safe.pipe';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-external-animal',
  templateUrl: './external-animal.component.html',
  styleUrls: ['./external-animal.component.css'],
  standalone: false,
})
export class ExternalAnimalComponent implements AfterViewInit {
  public animalUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) {}

  ngAfterViewInit() {
    this.route.params.subscribe((params) => {
      this.animalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(params['url']);

      this.cdr.detectChanges();
    });
  }
}
